var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"special_services"}},[_c('slider-section',{key:_vm.key,attrs:{"id":"normal-cards","obj":_vm.servicesRepo,"method":"getPage","sliderHolder":"specialServices","data":_vm.info}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }